import Vue from 'vue'
import { Watch } from 'vue-property-decorator'
import App from './App.vue'
import router from './router'
import store from './store'
import * as types from './store/types'
import Vue2TouchEvents from 'vue2-touch-events'
import { i18n } from '@appbase/util/i18n-setup'
import { initializeAsync as initAppBaseAsync } from '@appbase/module'

Vue.config.productionTip = false;

// infinite scroll
const infiniteScroll = require('vue-infinite-scroll')
Vue.use(infiniteScroll)

Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchHoldToTolerance: 300,
  swipeTolerance: 60,
  longTapTimeInterval: 400,
})

// //
// ────────────────────────────────────────────────────────────────── I ──────────
//   :::::: I N I T   V U E   R O O T : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────────────
//

Vue.prototype.setMenu = (name: string) => {
  store.commit(types.CURRENT_MENU, name)
}

Vue.prototype.isloading = (load: boolean) => {
  store.commit(types.GLOBAL_BUSY, load)
}

// new Vue({
//   router,
//   store,
//   i18n,
//   render: (h) => h(App),
// }).$mount('#app')
//

const bootstrap = async () => {
  await initAppBaseAsync()

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
}

bootstrap();
